/**
 * Copyright © Binary Anvil, Inc. All rights reserved.
 * See https://binaryanvil.com/software/license for license details.
 */
import React from "react";
import dynamic from 'next/dynamic'
import Facets from "@/app/components/algolia/facets/Facets";
const FacetsActive = dynamic(() => import("@/app/components/algolia/facets/FacetsActive"), {ssr: false});
import classes from "@/app/components/algolia/AlgoliaSidebar/algoliaSidebarStyles.module.scss";

const AlgoliaSidebar = (props: {facetsConfig:any}) => {
    return <>
        <FacetsActive facetsConfig={props.facetsConfig} className={classes['active-filters']} />
        <Facets facetsConfig={props.facetsConfig} className={classes['facets-wrapper']} />
    </>
}

export default AlgoliaSidebar;